import * as React from "react";

const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="7"
    height="7"
    viewBox="0 0 7 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0.353516 0.353516L6.35352 6.35352" stroke="white" />
    <path d="M6.35352 0.353516L0.353516 6.35352" stroke="white" />
  </svg>
);

export default CloseIcon;

